<template>
  <div class="auth">
    <form class="form sign-in">
      <p class="logo"><img src="../../assets/logo.svg" alt="logo" /></p>
      <div>
        <div class="form-wrap form-wrap-first">
          <input v-model="user.email" class="form-input" type="email" name="email" id="email" placeholder="E-Mail" />
        </div>
        <div class="form-wrap form-wrap-last">
          <input
            v-model="user.password"
            class="form-input"
            type="password"
            name="password"
            id="password"
            placeholder="••••••••••"
          />
        </div>
        <p>
          <input
            type="submit"
            value="Login"
            class="button button-green button-round button-100"
            @click.prevent="sessionLogin"
            @keyup.enter.prevent="sessionLogin"
          />
        </p>
        <div v-if="aadEnabled" class="external-login">
          <p class="divider">
            <span class="divider-text">{{ $t('auth.or') }}</span>
          </p>
          <input
            type="button"
            class="button button-blue button-round button-100 login-button"
            @click.prevent="adLogin"
            :value="$t('auth.adLogin')"
          />
        </div>
      </div>
    </form>
    <AppFooter :darkTextColor="false" />
  </div>
</template>

<script>
import AppFooter from '@/components/layout/AppFooter'

import { post } from '@/api/base'
import usersApi from '@/api/users'
import { loginWithAdRedirect } from '@/utils/active_directory_helper'

export default {
  name: 'auth_sign_in',
  data() {
    return {
      user: { email: '', password: '' },
    }
  },
  components: { AppFooter },
  methods: {
    async adLogin() {
      const result = await loginWithAdRedirect()
      if (result) this.afterLogin()
    },
    async sessionLogin() {
      const { success } = await post({
        path: '/auth/sign_in',
        params: this.user,
      })
      if (success) this.afterLogin()
    },
    async afterLogin() {
      // work around because we need App.vue#created to run again to get the user data, but we can't navigate at the same time
      window.location.href = '/'
    },
  },
  computed: {
    aadEnabled() {
      return !!process.env.VUE_APP_AAD_CLIENT_ID
    },
  },
  async mounted() {
    const user = await usersApi.getCurrent()
    if (user) this.afterLogin()
  },
}
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  height: 100vh;
  background: #314053;
  position: absolute;
  top: 0;
  left: 0;
}

.sign-in {
  padding-top: 100px;
  width: 50%;
  margin: auto;

  .logo {
    margin: 0 0 20px 0;
    text-align: center;

    img {
      max-width: 120px;
    }
  }

  .form-wrap {
    margin: 5px 0;
  }

  p {
    margin-top: 5px;
  }

  .external-login {
    color: #fff;
    text-align: center;
    .divider {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid #fff;
      line-height: 0.1em;
      margin: 25px 0 20px 0;
    }
    .divider-text {
      background: #314053;
      padding: 0 10px 0 10px;
    }
    .login-button {
      margin-top: 5px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .sign-in {
    width: 80%;
  }
}
</style>
